import React, { useState, useEffect, useContext } from "react";
import { validate } from './Validate';
import useForm from '../banner/customHooks';
import { X_TENANT_ID, PROMOTIONALPRODUCT_CAT } from '../../common/ActionUrl'
import axios from 'axios';
import { AuthContext } from "../../common/Auth"
import PromotionalProductCatDayForm from './PromotionalProductCatDayForm';
import { _useToasts } from "../../common/_useToasts";
import { USERTYPES } from "../../constant/userType";

const PromotionalProductCat = ({ proCatId, handleClose, fromEditAction }) => {

	const { user, userType, getFeaturedPromotionalProcutCat } = useContext(AuthContext)

	const { inputs, handleInputChange, handleSubmit, setImage, resetColor, handleColorPicker, handleFileInputChange, errors } = useForm({ productImage: "", title: "", description: "", createdBy: "", updatedBy: "", btnText: "", btnTextColor: "", btnBgColor: "", btnBgHoverColor: "", link: "", imageHeight: "" }, validate, updateCallback);

	const { _addToast } = _useToasts();
	const [data, seData] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const [tempImage, setTempImage] = useState("");
	const userId = user?.userId
	async function updateCallback() {

		const formData = new FormData();
		formData.append("productImage", inputs.productImage);
		formData.append("title", inputs.title);
		formData.append("description", inputs.description);
		formData.append("btnText", inputs.btnText);
		formData.append("btnTextColor", inputs.btnTextColor);
		formData.append("btnBgColor", inputs.btnBgColor);
		formData.append("btnBgHoverColor", inputs.btnBgHoverColor);
		formData.append("link", inputs.link);
		formData.append("imageHeight", inputs.imageHeight);
		formData.append("updatedBy", userId);

		const requestOptions = {
			headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
		};
		setIsLoading(true)
		if (proCatId) {
			axios.patch(PROMOTIONALPRODUCT_CAT + proCatId, formData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {
						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});
					} else {
						getFeaturedPromotionalProcutCat()
						handleClose()
					}
				}).catch(err => {
					console.log('err', err);
				});
		}
	}
	const getData = () => {
		setIsLoading(true)
		const requestOptions = {
			headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID },
		};
		axios.get(PROMOTIONALPRODUCT_CAT + proCatId, requestOptions)
			.then(res => {
				setIsLoading(false)
				if (res.data.error) {
					_addToast(res.data.message, {
						appearance: "error",
						autoDismiss: true
					});
				} else {
					seData(res.data)
				}
			})
			.catch(err => {
				console.log('err', err);
			});
	}

	useEffect(() => {
		if (proCatId) {
			getData()
		}
	}, [proCatId])

	//its a temp value for update inputs value when edit banner
	const [value, setValue] = useState(0);
	useEffect(() => {
		if (Object.keys(data).length > 0) {
			inputs.productImage = data.productImage
			inputs.title = data.title
			inputs.description = data.description
			inputs.updatedBy = data.updatedBy
			inputs.btnText = data.btnText
			inputs.btnTextColor = data.btnTextColor
			inputs.btnBgColor = data.btnBgColor
			inputs.btnBgHoverColor = data.btnBgHoverColor
			inputs.link = data.link
			inputs.imageHeight = data.imageHeight
			inputs.btnTextHoverColor = data.btnTextHoverColor
			setTempImage(data.productImage)
			setValue(value => value + 1);
		}
	}, [data])

	const deleteImage = () => {
		setTempImage("")
	}

	useEffect(() => {
		if (inputs.productImage != '' && inputs.productImage !== "undefined" && inputs.productImage !== undefined && inputs.productImage.name) {
			setTempImage(URL.createObjectURL(inputs.productImage))
		}
	}, [inputs.productImage])

	return (
		<>
			<div className="contact-area pt-10 pb-10">
				{userType !== USERTYPES.USER ?
					<>
						<PromotionalProductCatDayForm
							setImage={setImage}
							isLoading={isLoading}
							inputs={inputs}
							handleSubmit={handleSubmit}
							handleInputChange={handleInputChange} errors={errors}
							handleColorPicker={handleColorPicker}
							proCatId={proCatId}
							handleClose={handleClose}
							fromEditAction={fromEditAction}
							deleteImage={deleteImage}
							tempImage={tempImage}
							handleFileInputChange={handleFileInputChange}
							resetColor={resetColor}
						/>
					</> : <h2>You haven't authority for update deal of the day settings</h2>}
			</div>
		</>
	);
};

export default PromotionalProductCat;
